module.exports = __webpack_public_path__ + "img/Malaysia.9921f2c2.svg";